export function clamp(value: number, min: number, max: number): number {
  return value < min ? min : value > max ? max : value;
}

export function clamp01(value: number): number {
  return value < 0 ? 0 : value > 1 ? 1 : value;
}

export function approach(current: number, target: number, amount: number): number {
  if (current < target) return current + amount > target ? target : current + amount;
  if (current > target) return current - amount < target ? target : current - amount;
  return target;
}

export function lengthSquared(x: number, y: number): number {
  return x * x + y * y;
}

export function normalizeInto(x: number, y: number, out: Float32Array, offset = 0): void {
  const lenSq = x * x + y * y;
  if (lenSq <= 0.000001) {
    out[offset] = 0;
    out[offset + 1] = 0;
    return;
  }
  const inv = 1 / Math.sqrt(lenSq);
  out[offset] = x * inv;
  out[offset + 1] = y * inv;
}

export function quantizePixel(value: number): number {
  return value < 0 ? Math.ceil(value - 0.5) : Math.floor(value + 0.5);
}
